export default function PointGuide() {
  const earnMethods = [
    {
      icon: 'ri-shopping-cart-line',
      title: '通常のお買い物',
      rate: '1.2%',
      description: 'コンビニ、スーパー、ネットショッピングなど、どこで使っても100円につき1.2ポイント貯まります。'
    },
    {
      icon: 'ri-smartphone-line',
      title: '電子マネーチャージ',
      rate: '1.2%',
      description: '楽天Edy、モバイルSuica、SMART ICOCAへのチャージでも1.2%還元。二重取りでさらにお得です。'
    },
    {
      icon: 'ri-restaurant-line',
      title: '飲食店予約サービス',
      rate: '最大4.2%',
      description: '提携の飲食店予約サービスを利用すると、通常の1.2%に加えて最大3%の追加ポイントが貯まります。'
    },
    {
      icon: 'ri-hotel-line',
      title: '宿泊予約サービス',
      rate: '最大4.2%',
      description: '提携の宿泊予約サービスでの予約で、通常の1.2%に加えて最大3%の追加ポイントが獲得できます。'
    }
  ];

  const useMethods = [
    {
      icon: 'ri-exchange-line',
      title: 'Pontaポイントに交換',
      description: '1ポイント=1Pontaポイントで交換可能。ローソンやケンタッキーなど全国の提携店で使えます。'
    },
    {
      icon: 'ri-exchange-dollar-line',
      title: 'dポイントに交換',
      description: '1ポイント=1dポイントで交換可能。ファミリーマートやマクドナルドなどで利用できます。'
    },
    {
      icon: 'ri-gift-line',
      title: '商品・ギフト券に交換',
      description: 'Amazonギフト券や各種商品券、家電製品などの豊富な商品ラインナップから選べます。'
    },
    {
      icon: 'ri-plane-line',
      title: 'マイルに交換',
      description: 'JALマイルに交換可能。旅行好きの方にもおすすめの使い道です。'
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-6xl mx-auto px-4">
        <div className="mb-16">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-4">
            ポイントの貯め方
          </h2>
          <p className="text-center text-gray-600 mb-12 max-w-2xl mx-auto">
            日常のあらゆるシーンで高還元率のポイントが貯まります
          </p>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {earnMethods.map((method, index) => (
              <div
                key={index}
                className="bg-gradient-to-br from-orange-50 to-red-50 rounded-xl p-6 border border-orange-200 hover:shadow-lg transition-all duration-300"
              >
                <div className="w-14 h-14 bg-gradient-to-br from-orange-500 to-red-500 rounded-xl flex items-center justify-center mb-4">
                  <i className={`${method.icon} text-white text-2xl w-6 h-6 flex items-center justify-center`}></i>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">
                  {method.title}
                </h3>
                <div className="text-3xl font-bold text-orange-600 mb-3">
                  {method.rate}
                </div>
                <p className="text-sm text-gray-600 leading-relaxed">
                  {method.description}
                </p>
              </div>
            ))}
          </div>
        </div>

        <div>
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-4">
            ポイントの使い方
          </h2>
          <p className="text-center text-gray-600 mb-12 max-w-2xl mx-auto">
            貯まったポイントは様々な方法で活用できます
          </p>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {useMethods.map((method, index) => (
              <div
                key={index}
                className="bg-white rounded-xl p-6 shadow-lg border border-gray-200 hover:border-orange-300 hover:shadow-xl transition-all duration-300"
              >
                <div className="w-14 h-14 bg-orange-100 rounded-xl flex items-center justify-center mb-4">
                  <i className={`${method.icon} text-orange-600 text-2xl w-6 h-6 flex items-center justify-center`}></i>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-3">
                  {method.title}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  {method.description}
                </p>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 bg-gradient-to-r from-orange-50 to-red-50 rounded-xl p-8 border border-orange-200">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 bg-orange-500 rounded-lg flex items-center justify-center flex-shrink-0">
              <i className="ri-information-line text-white text-xl w-6 h-6 flex items-center justify-center"></i>
            </div>
            <div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">
                ポイント交換のコツ
              </h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                ポイントは最終利用日から1年間有効です。定期的にカードを利用していれば実質無期限で貯められます。Pontaポイントやdポイントへの交換は即時反映されるため、使いたいときにすぐ交換できて便利です。
              </p>
              <p className="text-gray-700 leading-relaxed">
                提携サービスでの予約時は、通常の1.2%還元に加えて最大3%の追加ポイントが貯まるため、合計で最大4.2%の超高還元率を実現できます。旅行や外食の際は積極的に活用しましょう。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
